// src/ui/PerlButton.jsx
import React from "react";
import { Button } from "@mui/material";

export default function PerlButton({
  children,
  onClick,
  disabled = false,
  variant = "contained",
  ...props
}) {
  return (
    <Button variant={variant} onClick={onClick} disabled={disabled} {...props}>
      {children}
    </Button>
  );
}
